import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useOpenCopilotButtonStyles = makeStyles({
  button: {
    ...shorthands.borderRadius('8px'),
    ...shorthands.padding('10px', '12px'),
    ...shorthands.borderStyle('none'),
    boxShadow: tokens.shadow4,
    height: 'auto',
    alignSelf: 'flex-start',
    minWidth: '244px',
    marginLeft: '16px',
    marginTop: '4px',
    '@media (max-width: 640px)': {
      minWidth: '96px',
      marginLeft: '0px',
      marginTop: '8px',
      width: '100%',
    },
  },
  contentContainer: { display: 'flex', columnGap: '8px' },
  image: { ...shorthands.padding('2px') },
});
